<template>
    <div>
        <p id="governance" class="text-h5 font-weight-bold mb-0 deep-purple lighten-5 pa-3 rounded">Projects with Governance Token - 4</p>
        <v-sheet
            class="mx-auto"
            color="grey lighten-5"
        >
            <v-slide-group
                v-model="model"
                class="pa-4"
                center-active
                show-arrows
            >
            <template v-slot:prev="{ on, attrs }" >
                <v-btn small fab color="deep-purple" v-bind="attrs" v-on="on" class="mr-5"
                ><v-icon color="white">mdi-arrow-left</v-icon></v-btn
                >
            </template>
            <template v-slot:next="{ on, attrs }">
                <v-btn small fab color="deep-purple" v-bind="attrs" v-on="on"
                ><v-icon color="white">mdi-arrow-right</v-icon></v-btn
                >
            </template>
                <v-slide-item
                v-for="(item, index) in governanceProjects" :key="index"
                v-slot="{ toggle }"
                >
                <v-card
                    class="ma-2"
                    elevation="4"
                    @click="toggle"
                    height="250"
                    min-width="150"
                    max-width="500"
                >
                    <v-list-item three-line>
                    <v-list-item-content>
                        <v-list-item-title class="text-h6 mb-1">
                        {{item.title}}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar
                        rounded
                        size="100"
                        color="grey"
                    ></v-list-item-avatar>
                    </v-list-item>

                    <v-list-item>
                    <span class="grey--text mr-3">Team name</span>
                    <span class="font-weight-bold">{{item.teamName}}</span>
                    </v-list-item>
                    <v-card-actions>
                    <v-spacer />
                    <v-btn text color="deep-purple" class="font-weight-bold" @click="viewProject">View More</v-btn>
                    </v-card-actions>
                </v-card>
                </v-slide-item>
            </v-slide-group>
        </v-sheet>
        <p id="tokens" class="text-h5 font-weight-bold mt-8 mb-0 deep-purple lighten-5 pa-3 rounded">Tokens used in Projects - 21</p>
        <v-container class="grey lighten-5" fluid>
            <v-row>
                <v-col
                    cols="4"
                    v-for="(item, index) in tokenProjects" :key="index"
                    >
                    <v-card
                        class="ma-1"
                        elevation="4"
                        height="250"
                        min-width="150"
                    >
                        <v-list-item three-line>
                        <v-list-item-content>
                            <v-list-item-title class="text-h6 mb-1">
                            <p class="text-body-1 font-weight-bold green--text">{{`${item.tokens} ${item.tokens === 1 ? 'Token' : 'Tokens'}`}}</p>
                            {{item.title}}
                            </v-list-item-title>
                            <v-list-item-subtitle>{{item.subtitle}}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar
                            rounded
                            size="100"
                            color="grey"
                        ></v-list-item-avatar>
                        </v-list-item>

                        <v-list-item>
                        <span class="grey--text mr-3">Team name</span>
                        <span class="font-weight-bold">{{item.teamName}}</span>
                        </v-list-item>
                        <v-card-actions>
                        <v-spacer />
                        <v-btn text color="deep-purple" class="font-weight-bold" @click="viewProject">View More</v-btn>
                        </v-card-actions>
                    </v-card>
                    </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
export default {
    props: ['section'],
    mounted() {
        if(this.section) {

            this.$vuetify.goTo(this.section, {offset: 10})
        }
    },
    data() {
        return {
            model: null,
            governanceProjects: [
                {
          title: "FINVOTE",
          subtitle: "A web page to show case all the hacka ideas. Share ideas accross the organisation",
          teamName: 'Pixie Normous',
                tokens: 1,
        },
        {
          title: "Weather forecasting system",
          subtitle: "Weather forecasting systems use a combination of science and technology to make accurate predictions on weather conditions of a particular location at a particular time",
          teamName: 'Raven Raiders',
                tokens: 4,
        },
        {
          title: "Credit card fraud detection",
          subtitle: "This credit card fraud detection system studies and analyzes user behavior patterns and uses location scanning techniques to identify any unusual patterns",
          teamName: 'Master Spinners',
                tokens: 3,
        },
        {
          title: "AI shopping system",
          subtitle: "As the name suggests, the AI multi-agent shopping system is a shopping assistant, more like a recommendation engine",
          teamName: 'Basic Boys',
                tokens: 2,
        },

            ],
            tokenProjects: [
        {
          title: "FINVOTE",
          subtitle: "A web page to show case all the hacka ideas. Share ideas accross the organisation",
          teamName: 'Pixie Normous',
                tokens: 1,
        },
        {
          title: "Weather forecasting system",
          subtitle: "Weather forecasting systems use a combination of science and technology to make accurate predictions on weather conditions of a particular location at a particular time",
          teamName: 'Raven Raiders',
                tokens: 4,
        },
        {
          title: "Credit card fraud detection",
          subtitle: "This credit card fraud detection system studies and analyzes user behavior patterns and uses location scanning techniques to identify any unusual patterns",
          teamName: 'Master Spinners',
                tokens: 3,
        },
        {
          title: "AI shopping system",
          subtitle: "As the name suggests, the AI multi-agent shopping system is a shopping assistant, more like a recommendation engine",
          teamName: 'Basic Boys',
                tokens: 2,
        },
        {
          title: "Bug tracker",
          subtitle: "This is a bug tracking application that helps identify and track bugs in projects or systems",
          teamName: 'Nans Lads',
                tokens: 2,
        },
        {
          title: "e-Learning platform",
          subtitle: "In this project, you will build a sharable e-learning platform using cloud computing infrastructure for online learning",
          teamName: 'Debuggers',
                tokens: 1,
        },
        {
          title: "Smart health prediction system",
          subtitle: "An intelligent health prediction system can transform the way people take charge of their health while also connecting them to the nearest healthcare providers immediately",
          teamName: 'Outliers',
                tokens: 3,
        },
        {
          title: "Sentiment analysis for product rating",
          subtitle: "This project aims to develop a sentiment analysis system for product rating. It is an e-commerce web application",
          teamName: 'Charging Hulks',
                tokens: 5,
        },

      ],
        }
    },
  methods: {
    viewProject() {
      this.$router.push({name: 'Project'})
    }
  }
}
</script>